import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { MemberProvider } from "./contexts/MemberContext";
import PublicLayout from "./components/Layout/PublicLayout";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import BookConsultation from "./pages/BookConsultation";
import Login from "./pages/Login";
import Register from "./pages/Register";
import PaymentSuccess from "./pages/PaymentSuccess";
import ClientPortal from "./pages/ClientPortal";
import AdminDashboard from "./pages/AdminDashboard";
import CaseStudies from "./pages/CaseStudies";
import GrantAutomation from "./pages/GrantAutomation";
import Resources from "./pages/Resources";
import Compliance from "./pages/Compliance";
import MemberPortal from "./pages/MemberPortal";
import MemberAuthCallback from "./pages/MemberAuthCallback";

function AppRoutes() {
  const location = useLocation();
  const hasMemberSessionId = location.hash?.includes("session_id=") || location.search?.includes("session_id=");
  const isMemberAuthRoute = location.pathname === "/member" || location.pathname === "/member/callback";
  const memberElement = hasMemberSessionId && isMemberAuthRoute ? <MemberAuthCallback /> : <MemberPortal />;

  return (
    <Routes>
      <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
      <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
      <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
      <Route path="/case-studies" element={<PublicLayout><CaseStudies /></PublicLayout>} />
      <Route path="/pricing" element={<PublicLayout><Pricing /></PublicLayout>} />
      <Route path="/resources" element={<PublicLayout><Resources /></PublicLayout>} />
      <Route path="/compliance" element={<PublicLayout><Compliance /></PublicLayout>} />
      <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
      <Route path="/book-consultation" element={<PublicLayout><BookConsultation /></PublicLayout>} />
      <Route path="/payment-success" element={<PublicLayout><PaymentSuccess /></PublicLayout>} />
      <Route path="/grant-writer" element={<ProtectedRoute role="admin"><PublicLayout><GrantAutomation /></PublicLayout></ProtectedRoute>} />
      <Route path="/member" element={<PublicLayout>{memberElement}</PublicLayout>} />
      <Route path="/member/callback" element={<PublicLayout><MemberAuthCallback /></PublicLayout>} />

      <Route path="/login" element={<PublicLayout><Login /></PublicLayout>} />
      <Route path="/register" element={<PublicLayout><Register /></PublicLayout>} />

      <Route path="/portal" element={<ProtectedRoute><ClientPortal /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <MemberProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </MemberProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
